module.exports = __webpack_public_path__ + "img/3.06f9b03b.png";